<template>
        <div id='bindcard'>
              <NavTop title='绑定银行卡'/>
              <div class="content" v-if="isset===true">
               <div class="bankshowcon">
                   <div class="bankshowcon-left"><van-icon name="debit-pay" size="0.6rem" /></div>
                   <div class="bankshowcon-right">
                       <div>{{bankname}}</div>
                       <div>{{bankcard}}</div>
                   </div>
               </div>       
              </div> 
              <div class='content' v-else-if="isset===false">
                  <div class="row">
                     <div class="label">银行</div>
                     <div class="maininput" @click="popBankBox"><input placeholder="请选择发卡银行" :value='choosedBankName' readonly/></div>
                     <div class="rightcon"><van-icon name="arrow" /></div>
                  </div>
                  <div class="row">
                     <div class="label">卡号</div>
                     <div class="maininput"><input placeholder="请输入银行卡号（仅支持储蓄卡）" :value='bankcard' @click="focusBankCardInput" type="number" readonly/></div>
                  </div>
                  <div class="tiprow">
                        <div class="tiprow-icon"><img src="~@/assets/img/security.png"/></div>
                        <div>信息加密处理，保障个人隐私不泄露</div>
                  </div>
                  <div class="row">
                     <div class="label">持卡人</div>
                     <div class="maininput">{{realname}}</div>
                  </div>
                  <div class="row">
                     <div class="label">身份证</div>
                     <div class="maininput"><input placeholder="请输入持卡对应身份证号" :value='idcard' @click="focusIDCardInput" type="text" readonly/></div>
                  </div>
                  <div class="tiprow">
                     <div>* 仅支持储蓄卡，暂不支持信用卡</div>
                   </div>
                   <div class="submitbtn_out">
                     <div class="submitbtn" @click="saveBankCard">提交</div>
                   </div>
              </div>
              <van-popup v-model="showBanklist" position="bottom" :style="{ height: '30%' }">
                  <div class="banktitle">请选择发卡银行</div>
                  <van-radio-group v-model="choosedBank">
                     <van-cell-group>
                     <van-cell  clickable v-for="item in banklist" :key="item.id" @click="setBank(item.id,item.bankname,item.bankcode)">
                        <template #title>
                           <div class="bankcon">
                              <div class="bankicon"><img :src="item.img"/></div>
                              <div class="banklabel">{{item.bankname}}</div> 
                           </div>
                        </template>
                        <template #right-icon>
                           <van-radio :name="item.id" />
                        </template>
                     </van-cell>
                     </van-cell-group>
                  </van-radio-group>
              </van-popup> 
            <van-number-keyboard
                        :show="showBankCardInput"
                        theme="custom"
                        close-button-text="完成"
                        @blur="showBankCardInput = false"
                        @input="onBankCardInput"
                        @delete="onBankCardDelete"
                        />   
            <van-number-keyboard
                        :show="showIDCardInput"
                        extra-key="X"
                        close-button-text="完成"
                        @blur="showIDCardInput = false"
                        @input="onIDCardInput"
                        @delete="onIDCardDelete"
                      />         
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import { Icon,Dialog,Popup,RadioGroup, Radio, Cell, CellGroup,NumberKeyboard   } from 'vant';

export default {
  data(){
      return{
         isset:'',
         realname:'',
         showBanklist:false,
         banklist:[],
         choosedBank:'',
         choosedBankName:'',
         choosedBankCode:'',

         showBankCardInput:false,
         showIDCardInput:false,
         bankcard:'',
         bankname:'',
         idcard:''
      }
  },  
  name: 'bindcard',
  created(){
      this.getList()
  },
  methods:{
      getList(){
         this.$post("/user/getUserInfo",{}).then((data)=>{
            if(data.result.success){
               if(data.result.info.realname==null || data.result.info.realname==''){
                  Dialog.confirm({
                     title: '温馨提醒',
                     message: '您的姓名还未设置，请设置完姓名后再来绑定',
                     })
                     .then(() => {
                         this.$go("/myprofile")
                     })
                     .catch(() => {
                         this.$go("/my")
                     });
               }else{
                   this.$post("/user/getBankList").then((data)=>{
                      if(data.result.success){
                           this.banklist=data.result.info
                      }
                   })
                   this.realname=data.result.info.realname
               }
               if(data.result.info.bankcard!=null){
                   this.isset=true
                   this.bankcard=data.result.info.bankcard
                   this.bankname=data.result.info.bankname
               }else{
                   this.isset=false
               }
            }else{
               this.$toast(data.result.info)
            }
         })
      },
      popBankBox(){
         this.showBanklist=true
      },
      setBank(bankid,bankname,bankcode){
         this.choosedBank =bankid
         this.choosedBankName=bankname
         this.choosedBankCode=bankcode
         this.showBanklist=false
      },
      saveBankCard(){
         if(this.choosedBankName==''||this.choosedBankCode==''){
            this.$toast("请先选择开户银行");return false;
         }
         if(this.bankcard==''||this.bankcard==undefined||this.bankcard==null){
            this.$toast("请先输入银行卡号");return false;
         }
         if(this.idcard==''||this.idcard==undefined||this.idcard==null){
            this.$toast("请先输入身份证号码");return false;
         }
         this.$post("/user/saveBankCard",{bankname:this.choosedBankName,bankcode:this.choosedBankCode,bankcard:this.bankcard,idcard:this.idcard}).then((data)=>{
             if(data.result.success){
                 this.$toast(data.result.info)
                 this.getList()
             }else{
                 this.$toast(data.result.info)
             }
         })
      },
      onBankCardInput(input){
          this.bankcard+=input
      },
      onBankCardDelete(){
          this.bankcard=this.bankcard.slice(0,-1)
      },
      focusBankCardInput(){
         this.showBankCardInput=true
      },
      onIDCardInput(input){
          this.idcard+=input
      },
      onIDCardDelete(){
          this.idcard=this.idcard.slice(0,-1)
      },
      focusIDCardInput(){
         this.showIDCardInput=true
      }
  },
  components:{
      NavTop,
      [Icon.name]:Icon,
      [Dialog.Component.name]: Dialog.Component,
      [Popup.name]:Popup,
      [RadioGroup.name]:RadioGroup,
      [Radio.name]:Radio,
      [CellGroup.name]:CellGroup,
      [Cell.name]:Cell,
      [NumberKeyboard.name]:NumberKeyboard 
  }
}
</script>
<style scoped>
#bindcard{background-color:#F6F6F6;min-height: 100vh;}
.content{border-radius: 0.2rem;background-color: #fff;display: flex;flex-flow: column nowrap;margin: 0.3rem;}
.row{padding: 0.4rem;display: flex;border-bottom: 1px solid #e7e7e7;}
.label{text-align: left;width:2.5rem;font-size:0.35rem;color:#333;}
.maininput{flex:1 0 auto;text-align: left;}
.maininput input{text-align: left;font-size:0.35rem;color:#333;width:100%;}
.submitbtn{background-color:#ee0a24;color:#fff;;font-size:0.35rem;padding: 0.25rem;border-radius: 0.1rem;}
.tiprow{font-size:0.25rem;display: flex;align-items: center;background-color: #F6F6F6;padding: 0.3rem;}
.tiprow-icon{display: flex;align-items: center;margin-right: 0.1rem;}
.tiprow-icon img{width:0.3rem;height:0.3rem;}
::v-deep .van-cell__title{text-align: left;}
.banktitle{font-size:0.42rem;padding: 0.2rem;}
.bankcon{display: flex;flex-flow: row nowrap;align-items: center;}
.bankicon{width:1.0rem;height:1.0rem;}
.banklabel{font-size:0.35rem;padding: 0.15rem;}
.bankshowcon{display: flex;align-items: center;flex-flow: row nowrap;padding: 0.35rem;}
.bankshowcon-left img{width:1.2rem;height:1.2rem;}
.bankshowcon-right{display: flex;flex-flow: column nowrap;text-align: left;padding-left: 0.3rem;}
</style>


